import { useFormikContext } from 'formik';
import get from 'lodash/get';
import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';

export default function AgreedToTermsCheckbox({ label, name, errorMessage }) {
  const form = useFormikContext();

  const { touched } = form;

  const shouldSHowError = get(touched, name, false) && errorMessage;

  return (
    <FormControl required error={!!errorMessage}>
      <FormControlLabel
        control={
          <Checkbox
            onChange={(e) => {
              if (e.target.checked) {
                form.setFieldValue(name, new Date());
              } else {
                form.setFieldValue(name, false);
              }
            }}
            name={name}
          />
        }
        label={label}
      />
      {shouldSHowError && (
        <FormHelperText>
          &nbsp; &nbsp; &nbsp;
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
}
